/**
 * @packageDocumentation
 * @module Object
 */
/**
 * Check if specific fields in an object will be updated
 *
 *
 * @param object Original object
 * @param toUpdate Updated value
 *
 * @return boolean
 */
export function hasChangesShallow(object, toUpdate) {
    // Using find because it stops on first match
    return Object.keys(toUpdate)
        .some(function (key) { return object[key] !== toUpdate[key]; });
}
//# sourceMappingURL=hasChangesShallow.js.map